/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/mastercard_card_medium'
export default icon
